var React = require('react');

function Linkedin (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M14 0C6.27 0 0 6.27 0 14s6.27 14 14 14 14-6.27 14-14S21.73 0 14 0zM9.932 21.164h-3.41V10.906h3.41v10.258zM8.227 9.505h-.022c-1.144 0-1.884-.787-1.884-1.772 0-1.006.762-1.772 1.929-1.772 1.166 0 1.884.766 1.906 1.772 0 .985-.74 1.772-1.929 1.772zm14 11.66h-3.41v-5.489c0-1.379-.494-2.32-1.727-2.32-.942 0-1.503.635-1.75 1.248-.09.219-.112.525-.112.832v5.728h-3.41s.045-9.296 0-10.258h3.41v1.452c.453-.699 1.264-1.693 3.073-1.693 2.243 0 3.925 1.466 3.925 4.617v5.882z"}));
}

Linkedin.defaultProps = {"width":"28","height":"28","viewBox":"0 0 28 28"};

module.exports = Linkedin;

Linkedin.default = Linkedin;
